'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H4 from 'UIComponents/elements/headings/H4';
import H5 from 'UIComponents/elements/headings/H5';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import UIIcon from 'UIComponents/icon/UIIcon';
import { HiddenAriaStatus } from 'MeetingsLib/components/decorative/HiddenAriaStatus';
import PreviewContext from 'MeetingsLib/utils/PreviewContext';
const displayName = 'PropertyFormHeader';
const propTypes = {
  userTimezone: PropTypes.string.isRequired,
  dateTime: PropTypes.number.isRequired,
  location: PropTypes.string,
  handleGoToPreviousStep: PropTypes.func.isRequired
};

const PropertyFormHeader = ({
  userTimezone,
  dateTime,
  location,
  handleGoToPreviousStep
}) => {
  const headerClasses = "p-x-8 p-top-8";
  const proposedMeetingDate = dateTime ? I18n.moment(dateTime).tz(userTimezone).format('LLLL') : '';
  return /*#__PURE__*/_jsxs("div", {
    id: "meeting-confirmation-form",
    className: headerClasses,
    "data-timestamp": dateTime,
    "data-selenium-test": "property-form-header",
    children: [/*#__PURE__*/_jsx(HiddenAriaStatus, {
      role: "status",
      "aria-live": "polite",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "accessible.formStatus",
        options: {
          proposedMeetingDate
        }
      })
    }), /*#__PURE__*/_jsx(H4, {
      className: "m-bottom-3",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `prebook.details.yourInfo`
      })
    }), /*#__PURE__*/_jsxs(UIFlex, {
      align: "baseline",
      justify: "start",
      children: [/*#__PURE__*/_jsx(H5, {
        className: "m-bottom-0",
        children: proposedMeetingDate
      }), /*#__PURE__*/_jsx(PreviewContext.Consumer, {
        children: isPreview => /*#__PURE__*/_jsx(UILink, {
          "aria-label": I18n.text('prebook.details.editLabel'),
          tabIndex: 0,
          className: "p-top-1 m-left-1",
          onClick: isPreview ? null : handleGoToPreviousStep,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'prebook.details.edit'
          })
        })
      })]
    }), location && /*#__PURE__*/_jsxs(UIFlex, {
      align: "baseline",
      justify: "start",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        screenReaderText: "meeting location",
        className: "p-right-1",
        name: "location",
        size: "xxs"
      }), location]
    })]
  });
};

PropertyFormHeader.displayName = displayName;
PropertyFormHeader.propTypes = propTypes;
export default PropertyFormHeader;